import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import dayjs from 'dayjs';

const firebaseRef = firebase.database();

export function getDepositBreakdown(leadId, fullPrice) {
	console.log('This is the fullprice', fullPrice);
	var firstDepositDate = dayjs();
	var secondDepositDate = dayjs().add(30, 'd');
	var thirdDepositDate = dayjs().add(90, 'd');
	var fourthDepositDate = dayjs().add(120, 'd');
	var fifthDepositDate = dayjs().add(180, 'd');

	var firstInstallment = 30000;
	var secondInstallment = (2.5 / 100) * fullPrice; // - firstInstallment;
	var thirdInstallment = (2.5 / 100) * fullPrice;
	var fourthInstallment = (5 / 100) * fullPrice;
	var fifthInstallment = (5 / 100) * fullPrice;

	var firstPercentage = parseFloat(
		(Number(firstInstallment) / Number(fullPrice)) * 100
	);

	console.log('firstPercentage', firstPercentage);

	var depositSchedule = [
		{
			date: dayjs(firstDepositDate).format('YYYY-MM-DD'),
			percentage: firstPercentage.toFixed(1),
			installment: firstInstallment,
		},
		{
			date: dayjs(secondDepositDate).format('YYYY-MM-DD'),
			percentage: 2.5,
			installment: secondInstallment,
		},
		{
			date: dayjs(thirdDepositDate).format('YYYY-MM-DD'),
			percentage: 2.5,
			installment: thirdInstallment,
		},
		{
			date: dayjs(fourthDepositDate).format('YYYY-MM-DD'),
			percentage: 5,
			installment: fourthInstallment,
		},
		{
			date: dayjs(fifthDepositDate).format('YYYY-MM-DD'),
			percentage: 5,
			installment: fifthInstallment,
		},
	];

	console.log('depositiooiSchedule', depositSchedule);
	console.log(
		'depositSchedule pattth',
		'/kavtek_agreements/' + PROJECT_CODE.projectCode + '/' + leadId
	);

	var leadRef = firebaseRef.ref(
		'/kavtek_agreements/' + PROJECT_CODE.projectCode + '/' + leadId
	);

	leadId &&
		leadRef.update({
			depositSchedule: depositSchedule,
		});

	return depositSchedule;
}
